import React, { useContext } from 'react';
import { CourseSection, Footer, MenuBar } from '../../layout/welcome';
import { MembershipContext } from '../../context/membership/membership';
import { Link } from "react-router-dom";
import { useHistory, useParams } from "react-router-dom";
import { useQuery } from "../../utils/query-parameter";
import { _retrieveData, _storeData } from "../../utils/local-storage";
import moment from "moment";
import useScrollBarPosition from "../../effect/Scroll";
import { useWindowSize } from "../../effect/WindowSize";
import { authGetRequest, getCourseItemAPI, getRequest } from "../../api/laravel/public/api";
import { HeaderText } from '../../components';
import { StudentCourse } from '../../layout/Dashboard';
import { settingContext } from '../../context/Setting/Setting';

const Index = () => {
    const size = useWindowSize();
    const router = useHistory();
    const param = useQuery();
    const { id } = useParams();
    // const { data } = getCourseItemAPI(course);
    const { membership } = useContext(MembershipContext);
    const [user, setUser] = React.useState({});
    // const { user } = useContext(AuthContext);
    const [data, setData] = React.useState([]);
    const [isLoading, setLoading] = React.useState(false);
    const [isPageLoader, setPageLoader] = React.useState(false);
    const [tab, setTab] = React.useState(0);
    // const { page, loading } = React.useContext(settingContext);
    const { page } = React.useContext(settingContext);
    const [loading, setLoadingn] = React.useState(false);
    const [modal, setModal] = React.useState(false);
    const playerRef = React.useRef(null);
    const [session, setSession] = React.useState(0);

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    // React.useEffect(() => {
    //     initialApi();
    // }, []);

    // const initialApi = async () => {
    //     setPageLoader(true);
    //     const pageData = await _retrieveData("page_data");
    //     if (pageData) {
    //         setPage(pageData);
    //         setPageLoader(true);
    //     }
    //     const { data_r, message, isError, isLoading } = await getRequest(
    //         `/auth/api/page`
    //     );
    //     setPage(data_r);
    //     setPageLoader(false);
    //     await _storeData(data_r, "page_data");
    // };

    React.useEffect(() => {
        getCourseList();
    }, []);

    const getCourseList = async () => {
        setPageLoader(true);
        const { data_r } = await getRequest("/course/list");
        setData(data_r);
        setPageLoader(false);
    };


    return (
        <div id="page-top" class="home">
            <div id="page-wrap">
                <MenuBar menuIndex="courses" setting={page?.setting} loader={isPageLoader} />
                <section className="sub-banner sub-banner-course">
                    <div className="awe-static bg-sub-banner-course" style={{ backgroundImage: 'url(../img/course_banner.jpeg)' }} />
                    <div className="awe-overlay" />
                    <div className="container">
                        <div className="sub-banner-content">
                            <h1 className="text-center text-white font-bold text-5xl">Our New Courses</h1>
                        </div>
                    </div>
                </section>
                <section className="course-top my-6">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    {data && data?.map((items, index) => (
                                        <Link key={index} to={"/course/" + items?.uuid} className={`col-xs-12 col-sm-6 col-md-3`}>
                                            <div className="mc-item mc-item-2">
                                                <div className="image-heading">
                                                    <img src={
                                                        items.poster.storage === "local"
                                                            ? process.env.REACT_APP_LOCAL_FILE_PATH +
                                                            items.poster.path +
                                                            "/medium/" +
                                                            items.poster.name
                                                            : items.poster.path
                                                    } alt="" />
                                                </div>
                                                <div className="meta-categories"><a>{items?.course_section?.length} Sections</a></div>
                                                <div className="content-item">
                                                    <div className="image-author">
                                                        {/* <img src="images/avatar-1.jpg" alt="" /> */}
                                                    </div>
                                                    <h4>{items.title}</h4>
                                                    <div className="name-author">
                                                        By <a href="#">{items?.created_by?.first_name}</a>
                                                    </div>
                                                </div>
                                                <div className="ft-item">
                                                    <div className="rating">
                                                        <a href="#" className="active" />
                                                        <a href="#" className="active" />
                                                        <a href="#" className="active" />
                                                        <a href="#" className="active" />
                                                        <a href="#" />
                                                    </div>
                                                    <div className="view-info">
                                                        {/* <i className="icon md-users" />
                      2568 */}
                                                    </div>
                                                    <div className="comment-info">
                                                        {/* <i className="icon md-comment" />
                      25 */}
                                                    </div>
                                                    <div className="price">

                                                        <span className="price-old"> {items.amount == 0 ? "Free" : items.amount}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    ))}


                                </div>

                            </div>
                        </div>
                    </div>
                </section>
                <Footer setting={page?.setting} />
            </div>
        </div>
    );
};

export default Index;